import Vue from "vue"
import Cookie from "js-cookie"
export default ({ store }) => {
  Vue.directive('has', {
    bind: function (el, binding) {
      if (!Vue.prototype.$_has(binding.value)) {
        el.style.display = 'none';
      }
    }
  });
  //权限检查方法
  Vue.prototype.$_has = function (value) {
    let isExist = false;
    let permissionList = store.state.app.permissionList
    if(!permissionList || permissionList.length <= 0) {
      let list = sessionStorage.getItem("permissionList");
      if (list && list.length > 0) {
        permissionList = list.split(",")
      }
      // permissionList = Cookie.get("permissionList").split(",")
    }
    // 权限列表
    for (let i = 0; i < permissionList.length; i++) {
      if (permissionList[i].indexOf(value) > -1) {
        isExist = true;
        break;
      }
    }
    return isExist;
  };
}
/**权限指令**/
